module.exports = __webpack_public_path__ + "img/y-41.66867d14.png";